/* eslint-disable @typescript-eslint/no-type-alias */
export type DocumentType = 'amendment' | 'base_lease' | 'other';

/** The SharePoint file a document was read from (SharePoint connector) */
export interface SharePointLink {
  url: string;

  /** The file changed in SharePoint after Strada read it, and hasn't been reprocessed yet */
  newer_version: boolean;
}

export interface LeaseDocument {
  id: number;
  document_type: DocumentType;
  effective_date: string | null;
  original_filename: string;
  pdf_url: string;
  download_url: string | null;
  ordinal: number;
  is_processed: boolean;
  progress: number;
  message: string;
  created: string;

  /** Attached from an upload by amendment auto-detection (matches backend auto_attached) */
  auto_attached: boolean;
  sharepoint: SharePointLink | null;
}

/** Upload that looks like an amendment of another lease (same building + suite, different tenant name) */
export interface AmendmentSuggestion {
  target_lease_id: number;
  target_tenant: string;
  reason: string;
}

export interface LeaseListItem {
  id: number;
  building_name: string;
  property_id: number | null;
  tenant_name: string;
  unit_suite: string;
  lease_start_date: string | null;
  lease_expiration_date: string | null;
  has_options: boolean;
  amendment_count: number;
  modified: string;
  is_processing: boolean;
  // Set while the daily upload limit holds the lease back (a Strada superadmin approves or declines it)
  processing_status: 'awaiting_approval' | 'declined' | null;
  is_processed: boolean;
  progress: number;
  message: string;
  amendment_suggestion: AmendmentSuggestion | null;
}

export interface LeaseDetail extends LeaseListItem {
  documents: LeaseDocument[];
  lease_agreement_date: string;
  expiration_source: string;
}

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  base_lease: 'Base Lease',
  amendment: 'Amendment',
  other: 'Other',
};

export const DOCUMENT_TYPE_STYLES: Record<DocumentType, { bg: string; text: string }> = {
  base_lease: { bg: '#E8F5E9', text: '#2E7D32' },
  amendment: { bg: '#FFF3E0', text: '#E65100' },
  other: { bg: '#F3F4F6', text: '#6B7280' },
};
